<template>
  <li class="spar-slider-item glide__slide">
    <slot />
  </li>
</template>
